// based on 2.0.0
import TouchFeedback from './src/TouchFeedback';
export default TouchFeedback;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_ant-design-vue@1.7.8@ant-design-vue/es/vc-m-feedback/index.js
// module id = null
// module chunks = 